import type { FilterField } from './WarehouseFilter';
import {
  METHOD_LABEL,
  OUTBOUND_SOURCE_LABEL,
  PO_TYPE_LABEL,
  SKU_STATUS,
} from './shared';

// "Filter" fields per Warehouse list — the logistic web's filterFields minus
// what only ops pick (Client, Vendor, upload batch, storage tree). Keys are
// the API params of each list (and of its tab counts and CSV export).

const CREATED: FilterField = {
  kind: 'date',
  key: 'date',
  label: 'Tanggal dibuat',
  presets: 'past',
};

const PO_TYPE: FilterField = {
  kind: 'enum',
  key: 'type',
  label: 'Tipe',
  options: Object.entries(PO_TYPE_LABEL).map(([value, label]) => ({
    value,
    label,
  })),
};

export const STOCK_FILTERS: readonly FilterField[] = [
  { kind: 'date', key: 'expiry', label: 'Kedaluwarsa', presets: 'future' },
];

export const SKU_FILTERS: readonly FilterField[] = [
  {
    kind: 'enum',
    key: 'status',
    label: 'Status',
    options: Object.entries(SKU_STATUS).map(([value, meta]) => ({
      value,
      label: meta.label,
    })),
  },
  {
    kind: 'text',
    key: 'productCategory',
    label: 'Product category',
    placeholder: 'mis. Obat bebas',
  },
];

export const OUTBOUND_FILTERS: readonly FilterField[] = [
  {
    kind: 'enum',
    key: 'type',
    label: 'Tipe',
    options: [
      { value: 'REGULAR', label: 'Regular' },
      { value: 'TRANSFER', label: 'Transfer' },
    ],
  },
  {
    kind: 'enum',
    key: 'source',
    label: 'Sumber',
    options: Object.entries(OUTBOUND_SOURCE_LABEL).map(([value, label]) => ({
      value,
      label,
    })),
  },
  {
    kind: 'enum',
    key: 'method',
    label: 'Metode',
    options: [{ value: 'DELIVERY', label: METHOD_LABEL.DELIVERY }],
  },
  CREATED,
  { kind: 'date', key: 'delivery', label: 'Tanggal kirim', presets: 'future' },
];

export const PO_FILTERS: readonly FilterField[] = [
  PO_TYPE,
  CREATED,
  { kind: 'date', key: 'arrival', label: 'Estimasi tiba', presets: 'future' },
];

export const INBOUND_FILTERS: readonly FilterField[] = PO_FILTERS;
